import {Component, OnInit} from '@angular/core';
import {HelperService} from './helper.service';

@Component({
    selector: 'app-helper',
    templateUrl: './helper.component.html',
    styleUrls: ['./helper.component.scss']
})
export class HelperComponent implements OnInit {

    public displayedColumns: string[] = ['id', 'date','deleted', 'name'];

    constructor (
        public _helperService: HelperService
        ) { 
            this._helperService.selectTopics();
        }

    ngOnInit () {
    }

}
